// extracted by mini-css-extract-plugin
export default {"wrapper":"FirstStep_wrapper__KBXuO","wrapper__title":"FirstStep_wrapper__title__DmERg","wrapper__row":"FirstStep_wrapper__row__2C2Pq"};